/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const HeartFilled = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M11.3659 4.79808L12.2253 5.66556L13.0864 4.79808C15.4619 2.40064 19.3133 2.40064 21.6888 4.79808C24.0643 7.19551 24.0158 10.7106 21.6888 13.48C20.1374 15.3262 16.9366 18.1306 12.0864 21.8932C7.42245 18.1306 4.31483 15.3262 2.76348 13.48C0.436471 10.7106 0.387997 7.19551 2.76348 4.79808C5.13897 2.40064 8.9904 2.40064 11.3659 4.79808Z"
                        fill={color}
                    />
                </svg>
        );
    };
